<div class="table-wrapper custom-table">
  <mat-table #table matSort matSortActive="EmployerName" matSortDirection="asc" matSortDisableClear [dataSource]="dataSource.workedDays$ | async">
    <ng-container matColumnDef="employerName">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
        {{ 'WorkedDays.Employer' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.EmployerName }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="workedDays">
      <mat-header-cell *matHeaderCellDef>
        {{ 'WorkedDays.36MonthsWorkedDays' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.WorkedDays }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="workerAgreementWorkedDays">
      <mat-header-cell *matHeaderCellDef>
        {{ 'WorkedDays.AgreementsWorkedDays' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.WorkerAgreementWorkedDays }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="employmentHistoryWorkedDays">
      <mat-header-cell *matHeaderCellDef>
        {{ 'WorkedDays.WorkerEmploymentHistoryWorkedDays' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.EmploymentHistoryWorkedDays }}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="calculationDate">
      <mat-header-cell *matHeaderCellDef>
        {{ 'WorkedDays.CalculationDate' | translate }}
        <app-table-header-sort></app-table-header-sort>
      </mat-header-cell>
      <mat-cell *matCellDef="let element">{{ element.CalculationDate | date : 'dd.MM.yyyy' }}</mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>

<mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
